export const EntitiesGrid = require("./entitiesGrid").default
export const DossierGrid = require("./dossierGrid").default

export const DocumentTypeGrid = require("./documentTypeGrid").default
export const EntityForm = require("./entityForm").default
export const RevisionGrid = require("./revisionsGrid").default



